module.exports = __webpack_public_path__ + "static/media/footer.f5e7af03.png";